// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.batch-management-container {
  display: flex;
  justify-content: space-between;
  align-items: flex-start;
  max-width: 800px;
  margin: 20px auto;
}

.batches-list,
.selected-batches {
  flex-basis: 45%;
}

ul {
  list-style: none;
  padding: 0;
}

li {
  margin-bottom: 10px;
}

label {
  margin-left: 5px;
}

.action-buttons {
  display: flex;
  flex-direction: column;
  align-items: center;
  margin-top: 20px;
}

.custom-button {
  display: "d-flex";
  justify-content: center;
  text-align: center;
}

button {
  background-color: #4caf50;
  color: white;
  padding: 10px 15px;
  border: none;
  border-radius: 5px;
  cursor: pointer;
}

button:hover {
  background-color: #45a049;
}

table {
  width: 100%;
  border-collapse: collapse;
  margin-top: 0px;
}

th,
td {
  border: 1px solid #ddd;
  padding: 8px;
  text-align: left;
  text-align: center;
}

th {
  background-color: #cfecf6 !important;
  color: white;
}

.heading1 {
  font-family: poppins;
  font-size: 24px;
  font-weight: 700;
  line-height: 30px;
}

.radio-container {
  display: flex;
  gap: 20px;
  margin: 10px;
}

.radio-option {
  display: flex;
  align-items: center;
}

input[type="radio"] {
  width: 20px;
  height: 20px;
  border-radius: 50%;
  outline: none;
  margin-right: 8px;
  cursor: pointer;
}

label {
  cursor: pointer;
  font-size: 16px;
  color: #333;
}

@media (max-width: 844px) {
  .check_btn {
    display: grid;
    justify-content: center;
    text-align: center;
  }
  .bpt {
    overflow: scroll;
  }
}
`, "",{"version":3,"sources":["webpack://./src/pages/NewHarvest/index.css"],"names":[],"mappings":"AAAA;EACE,aAAa;EACb,8BAA8B;EAC9B,uBAAuB;EACvB,gBAAgB;EAChB,iBAAiB;AACnB;;AAEA;;EAEE,eAAe;AACjB;;AAEA;EACE,gBAAgB;EAChB,UAAU;AACZ;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,mBAAmB;EACnB,gBAAgB;AAClB;;AAEA;EACE,iBAAiB;EACjB,uBAAuB;EACvB,kBAAkB;AACpB;;AAEA;EACE,yBAAyB;EACzB,YAAY;EACZ,kBAAkB;EAClB,YAAY;EACZ,kBAAkB;EAClB,eAAe;AACjB;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,WAAW;EACX,yBAAyB;EACzB,eAAe;AACjB;;AAEA;;EAEE,sBAAsB;EACtB,YAAY;EACZ,gBAAgB;EAChB,kBAAkB;AACpB;;AAEA;EACE,oCAAoC;EACpC,YAAY;AACd;;AAEA;EACE,oBAAoB;EACpB,eAAe;EACf,gBAAgB;EAChB,iBAAiB;AACnB;;AAEA;EACE,aAAa;EACb,SAAS;EACT,YAAY;AACd;;AAEA;EACE,aAAa;EACb,mBAAmB;AACrB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,kBAAkB;EAClB,aAAa;EACb,iBAAiB;EACjB,eAAe;AACjB;;AAEA;EACE,eAAe;EACf,eAAe;EACf,WAAW;AACb;;AAEA;EACE;IACE,aAAa;IACb,uBAAuB;IACvB,kBAAkB;EACpB;EACA;IACE,gBAAgB;EAClB;AACF","sourcesContent":[".batch-management-container {\n  display: flex;\n  justify-content: space-between;\n  align-items: flex-start;\n  max-width: 800px;\n  margin: 20px auto;\n}\n\n.batches-list,\n.selected-batches {\n  flex-basis: 45%;\n}\n\nul {\n  list-style: none;\n  padding: 0;\n}\n\nli {\n  margin-bottom: 10px;\n}\n\nlabel {\n  margin-left: 5px;\n}\n\n.action-buttons {\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  margin-top: 20px;\n}\n\n.custom-button {\n  display: \"d-flex\";\n  justify-content: center;\n  text-align: center;\n}\n\nbutton {\n  background-color: #4caf50;\n  color: white;\n  padding: 10px 15px;\n  border: none;\n  border-radius: 5px;\n  cursor: pointer;\n}\n\nbutton:hover {\n  background-color: #45a049;\n}\n\ntable {\n  width: 100%;\n  border-collapse: collapse;\n  margin-top: 0px;\n}\n\nth,\ntd {\n  border: 1px solid #ddd;\n  padding: 8px;\n  text-align: left;\n  text-align: center;\n}\n\nth {\n  background-color: #cfecf6 !important;\n  color: white;\n}\n\n.heading1 {\n  font-family: poppins;\n  font-size: 24px;\n  font-weight: 700;\n  line-height: 30px;\n}\n\n.radio-container {\n  display: flex;\n  gap: 20px;\n  margin: 10px;\n}\n\n.radio-option {\n  display: flex;\n  align-items: center;\n}\n\ninput[type=\"radio\"] {\n  width: 20px;\n  height: 20px;\n  border-radius: 50%;\n  outline: none;\n  margin-right: 8px;\n  cursor: pointer;\n}\n\nlabel {\n  cursor: pointer;\n  font-size: 16px;\n  color: #333;\n}\n\n@media (max-width: 844px) {\n  .check_btn {\n    display: grid;\n    justify-content: center;\n    text-align: center;\n  }\n  .bpt {\n    overflow: scroll;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
